(function () {

  "use strict";

  angular.module("PrinterPropertiesMulti")

    .controller("PrinterPropertiesMultiController", [
      "$rootScope", "$scope", "$filter", "$location", "URLS", "PrinterListService", "toastr", "PRINTER_TYPES",
      "$routeParams", "URL_PARAMS", '$window', 'EventHandlerService',
      'currentTenant', '$timeout', 'PrinterListPOSTPaging',
      'enums', 'RegexModel', '$http',
      function (
        $rootScope, $scope, $filter, $location, URLS, PrinterListService, toastr, PRINTER_TYPES,
        $routeParams, URL_PARAMS, $window, EventHandlerService,
        currentTenant, $timeout, PrinterListPOSTPaging,
        enums, RegexModel, $http) {

        $scope.me = null;
        var regex = new RegexModel();
        $scope.thresholdToSwitchCreatedTimeFormat = 6;
        $scope.printers = null;
        $scope.printersOriginal = null;
        $scope.urls = URLS;
        $scope.printerTypes = PRINTER_TYPES;
        $scope.printerPropertiesMulti = {};
        $scope.printersUpdated = 0;

        $scope.location = '';
        $scope.locationInvalid = false;
        $scope.selectedNetwork = null;
        $scope.selectedNetworkIdAsArray = null;
        $scope.selectedSNMP = null;

        $scope.snmpConfigurationResources = null;
        $scope.eventHandlerService = EventHandlerService;

        const printerListPage = new PrinterListPOSTPaging();
        $scope.windowWidth = $window.innerWidth;
        $scope.loadingPage = true;

        const BAD_STRING_NAME = new RegexModel().badNameString().regex;
        $scope.BAD_STRING_NAME = new RegexModel().badNameString().string;

        $scope.$watch(function () {
          return $rootScope.currentUser;
        }, function () {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
          }
        });

        let protocolList = [];

        let protocolPortMap = {
          IPPS: 443,
          IPP: 80,
          LPR: 515,
          RAW: 9100
        };

        function PortProtocolConstructor() {
          this.protocol = null;
          this.port = null;
          this.queueName = '';
          this.protocolCompatibilty = {};
          this.protocolConflict = false;
          this.resetToDefault = false;
          this.portIsValid = false;
          this.pathIsValid = false;
          this.isValid = false;
          this.ippSupportedPath = null;
          this.choosenPathOption = null;
          this.isPristine = true;

          this.setPathOption = () => {
            switch (this.ippSupportedPath) {
              case '/':
                this.choosenPathOption = 'ROOT'
              break;
              case '/ipp/print':
                this.choosenPathOption = 'IPP_PRINT'
              break;
              default:
                this.choosenPathOption = 'ENTER_PATH'
              break;
            }
          }

          this.updateProtocol = (protocol) => {
            this.protocol = protocol.info.name;
            this.port = protocolPortMap[this.protocol];
            this.isPristine = false;

            // if (this.protocol !== 'LPR') {
            //   this.queueName = '';
            // }

            // if (this.protocol !== 'IPP' || this.protocol !== 'IPPS') {
            //   this.ippSupportedPath = '';
            // }

            this.ippSupportedPath = null;
            this.queueName = '';
            if (this.protocol.indexOf('IPP') > -1) {
              this.ippSupportedPath = '/ipp/print';
              this.setPathOption();
            }
            this.isValid = this.validatePortProtocol();
            return this;
          }

          this.mapProtocolCompitability = function (printers) {
            switch (this.protocol) {
              case 'RAW':
              case 'LPR':
                printers.forEach((printer) => { this.protocolCompatibilty[printer.customProperties.id] = true});
              break;
              case 'IPP':
                printers.forEach((printer) => {
                  if (printer.info.ippSupport === 'NONE') {
                    this.protocolCompatibilty[printer.customProperties.id] = false
                  } else {
                    this.protocolCompatibilty[printer.customProperties.id] = true
                  }
                });
              break;
              case 'IPPS':
                printers.forEach((printer) => {
                  if (printer.info.ippSupport === 'NONE' || printer.info.ippSupport === 'IPP') {
                    this.protocolCompatibilty[printer.customProperties.id] = false
                  } else {
                    this.protocolCompatibilty[printer.customProperties.id] = true
                  }
                });
              break;
            }

            this.testProtocolCompatibility();
          }

          this.testProtocolCompatibility = function () {
            this.protocolConflict = !Object.values(this.protocolCompatibilty).every((test) => test === true);
          }

          this.testSavePortProtocol = function (printer) {
            if (this.port && !this.protocol) {
              return true;
            } else if (this.protocol && this.protocolCompatibilty[printer.customProperties.id]) {
              return true;
            } else {
              return false;
            }
          }

          this.validatePortProtocol = function () {

            switch(this.protocol){
              case 'IPP':
              case 'IPPS':
                return this.validatePortRange() && this.validatePath();
              break;
              case 'LPR':
                return this.validatePortRange() && this.queueName.length > 0;
              break;
              case 'RAW':
                return this.validatePortRange();
              break;
            }
          }

          this.validatePortRange = function () {
            if (regex.portRegex().test(this.port)) {
              this.portIsValid = true;
              return true
            }
            this.portIsValid = false;
            return false
          }

          this.validatePath = function () {
            if (regex.pathRegex().test(this.ippSupportedPath) || this.ippSupportedPath.length === 0) {
              this.pathIsValid = true;
              return true
            }
            this.pathIsValid = false;
            return false
          }



          this.resetPortProtocol = function () {
            this.protocol = null;
            this.port = null;
            this.queueName = null;
            this.protocolCompatibilty = {};
            this.protocolConflict = false;
            this.portIsValid = false;
            this.ippSupportedPath = null;
          }
        }

        function ProtocolListConstructor(protocolEnums) {
          return protocolEnums.map((protocol) => {
            return {
              info: {
                name: protocol.name,
                id: protocol.id
              }
            }
          })
        }

        (function () {
          initEventHandler();
          setListeners();
          initView();
        })();

        function initView() {
          $scope.location = '';
          $scope.selectedNetwork = null;
          $scope.selectedNetworkIdAsArray = null;
          $scope.selectedSNMP = null;
          getPrinters();
          $scope.portProtocol = new PortProtocolConstructor();
          protocolList = ProtocolListConstructor(enums.PrintProtocol);
        }

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        }

        function isSnmpConfigurationValidForNetwork() {
          let snmp = $scope.selectedSNMP;
          if (!snmp || !snmp.info.networkIds || !snmp.info.networkIds.length) {
            return true;
          }
          let network = $scope.selectedNetwork;
          if (network && snmp.info.networkIds.includes(network.customProperties.id)) {
            return true;
          }
          return false;
        }

        function getPrinters() {
          const printerIds = $location.path().split('/printerPropertiesMulti/')[1].split(',');
          printerListPage.pagingCriteria.printers = printerIds;
          printerListPage.pagingCriteria.types = ["NETWORK", "VIRTUAL"];
          PrinterListService.postGetPrinterListPaged(printerListPage).then((response) => {
            $scope.snmpConfigurationResources = response.snmpConfigurationResources;
            $scope.printers = mapAdditionalResources(response);
            $scope.loadingPage = false;
          }).catch((error) => {
            $scope.loadingPage = false;
          });
        }

        function mapAdditionalResources (response) {
          response.list.forEach((printer) => {
            printer.customProperties.network = response.networks.find(network => network._links.self.href === printer.info._links['px:network'].href);
            const snmpHref = printer.info._links['px:snmpConfiguration']?.href;
            if (snmpHref) {
              printer.customProperties.snmp = $scope.snmpConfigurationResources.find(snmp => snmp._links.self.href.split('snmp/')[1] === snmpHref.split('snmp/')[1]);
            }
            if (printer.info.ipAddress.indexOf('$$') > 0) {
              printer.customProperties.protocolOverride = '$$' + printer.info.ipAddress.split('$$')[1];
            } else if (printer.info.ipAddress.indexOf('\\\\') == 0) {
              printer.customProperties.protocolOverride = '\\\\' + printer.info.ipAddress.split('\\\\')[1];
            } else {
              printer.customProperties.protocolOverride = null;
            }
          })
          return response.list;
        }

        $scope.printPrinterIdSigns = function() {
          var printerURLArray = [];
          angular.forEach($scope.printers, function(printer) {
            printerURLArray.push(printer.customProperties.id);
          });
          $location.path(URLS.PRINTER_ID_SIGN.replace(URL_PARAMS.PRINTER_URL.LOCATION, printerURLArray));
        };

        $scope.downloadPrinterIdSigns = function() {
          var printerIds = [];
          angular.forEach($scope.printers, function(printer) {
            if (printer.info.type !== 'FREEDOM') {
              var printerId = printer.info._links.self.href.split('/');
              var lastIndex = printerId.length -1;
              printerIds.push(printerId[lastIndex]);
            }
          });

          printerIds = JSON.stringify(printerIds).replace(/[^\w\s,-]/gi, '');
          const url = 'https://' + currentTenant.info.apiEndpoint + '/v1/tenants/' + currentTenant.customProperties.id + '/printers/qrData' + '?printerIds=' + printerIds;
          const config = {headers: { "Accept": "text/csv" }};
          $http.get(url, config).then((response) => {
              var blob = new Blob([response.data], { type: 'text/csv' });
              var url = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url;
              a.download = "signIds.csv";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          }).catch((error) => {});

        }

        $scope.saveChanges = function (event, context, menuOption, mappedNetworks){
          $scope.suppressSaveButton = true;

          $timeout(function  () {
            if (event, context, menuOption) {
              $scope.selectedContextMenuItem  =  menuOption;
              $scope.contextPosition =  { left: event.clientX, top: event.clientY };
              $scope.context = context;
              $scope.context.location = $scope.location ? $scope.location : '';
              $scope.context.selectedNetwork = $scope.selectedNetwork || null;
              $scope.context.selectedSNMP = $scope.selectedSNMP || null;
              $scope.context.printers = $scope.printers ? $scope.printers : null;
              $scope.context.portProtocol = $scope.portProtocol;
            }
          }, 50)
        };

        $scope.openDialog = function (event, context, menuOption) {
          $scope.selectedContextMenuItem  =  menuOption;
          $scope.contextPosition =  { left: event.clientX, top: event.clientY };
          $scope.context = context;
          $scope.context.portProtocol = $scope.portProtocol;
        }

        $scope.closeAllMenues = function () {
          $scope.suppressSaveButton = false;
          $scope.selectedContextMenuItem  =  null;
          $scope.contextPosition = null;
          $scope.context = null;
        }

        $scope.removePrinter = function (printer) {
          const printerIds = $routeParams[URL_PARAMS.PRINTER_URL.ROUTE].split(",");
          const newPrinterIds = printerIds.filter(printerId => printerId !== printer.customProperties.id);
          $scope.printers = $scope.printers.filter(printerInList => printerInList.customProperties.id !== printer.customProperties.id)
          if (arrayIsEmpty()) {
            $location.path(URLS.PRINTER_LIST);
          } else {
            $location.path(URLS.PRINTER_PROPERTIES_MULTI.replace(URL_PARAMS.PRINTER_URL.LOCATION, newPrinterIds), false);
          }
        }

        function arrayIsEmpty() {
          if ($scope.printers.length < 1 ) {
            toastr.warning($filter("translate")("NoPrinters"))
            return true;
          }
          return false;
        }

        $scope.openNetworkSelector = function () {
          $scope.networkSelectorIsOpen = true;
        }

        $scope.onNetworkSelected = function (network) {
          $scope.selectedNetwork = network || null;
          $scope.selectedNetworkIdAsArray = network ? [network.customProperties.id] : null;
          $scope.networkSelectorIsOpen = false;

          if (!isSnmpConfigurationValidForNetwork()) {
            $scope.selectedSNMP = null;
          }
      }

        $scope.openSnmpConfigurationSelector = function () {
          $scope.snmpConfigurationSelectorIsOpen = true;
        }

        $scope.onSnmpConfigurationSelected = function (snmpConfiguration) {
          $scope.selectedSNMP = snmpConfiguration || null;
          $scope.snmpConfigurationSelectorIsOpen = false;
        }

        $scope.selectProtocolList = function () {
          $scope.protocolList = protocolList;
        }

        $scope.selectProtocol = function (protocol) {
          if (protocol) {
            $scope.portProtocol.updateProtocol(protocol);
            $scope.portProtocol.mapProtocolCompitability($scope.printers);
          } else {
            $scope.portProtocol = new PortProtocolConstructor();
          }
          $scope.protocolList = null;
        }

        $scope.checkPort = function () {
          if ($scope.portProtocol.isPristine) {
            $scope.portProtocol.validatePortRange()
          } else {
            $scope.portProtocol.isValid = $scope.portProtocol.validatePortProtocol();
          }
        }

        $scope.validatePort = function () {
          if ($scope.portProtocol.isPristine) {
            $scope.portProtocol.validatePortRange()
          } else {
            $scope.portProtocol.isValid = $scope.portProtocol.validatePortProtocol();
          }
        }

        $scope.validateQueuename = function () {
          $scope.portProtocol.isValid = $scope.portProtocol.validatePortProtocol();
        }

        $scope.resetToDefaultPortProtocol = function () {
          $scope.portProtocol.resetPortProtocol()
        }

        $scope.validateLocation = function () {
          if (BAD_STRING_NAME.test($scope.location)) {
            $scope.locationInvalid = true
          } else {
            $scope.locationInvalid = false
          }
          console.log('** $scope.locationInvalid : ', $scope.locationInvalid);
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        $scope.showTooltip = function (showTip, position, tooltipScope, context, printer) {

          if (showTip && context) {
            switch(tooltipScope) {
              case 'site':
                siteTooltip(position, context, printer);
              break;
              case 'networkTooltip':
                networkDetails(position, context);
              break;
              case 'snmpDescription':
                snmpDescription(position, context);
              break;
              case 'printer':
                printerTooltip(position, context);
              break;
              case 'protocolOverride':
                protocolOverrideTooltip(position, context);
              break;
              case 'protocol':
                protocolTooltip(position, context, printer);
              break;
            }
          } else {
            $scope.clearTooltip();
          }
        }

        function protocolOverrideTooltip (position, printer) {
          let tooltip = $filter('translate')('ManuallyConfigured') + ' : ' + printer.info.ipAddress

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: tooltip,
            type: 'statement',
          }

          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        function protocolTooltip (position, title, printer) {
          let tooltip = title;

          if ($scope.portProtocol.protocol === 'LPR') {
            tooltip += ' / ' + $scope.portProtocol.queueName;
          } else if (printer.info._embedded.portProtocol.protocol === 'LPR' && !$scope.portProtocol.protocol) {
            tooltip += ' / ' + printer.info._embedded.portProtocol.queueName;
          }

          if ($scope.portProtocol.protocol && !$scope.portProtocol.protocolCompatibilty[printer.customProperties.id] && !printer.customProperties.protocolOverride) {
            tooltip = $filter('translate')('ProtocolNotSupported');
          }

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: tooltip,
            type: 'statement',
          }

          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        function siteTooltip (position, title) {
          let tooltip = title;

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: tooltip,
            type: 'statement',
          }

          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        function networkDetails (position, network) {
          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: network.info.name,
            type: 'networkAllDetails',
            network: network,
          }
          $scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: false
          }
        }

        function snmpDescription (position, snmp) {
          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: snmp.info.name,
            type: 'snmpDescription',
            snmpConfiguration: snmp,
          }
          $scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: false
          }
        }

        function printerTooltip (position, printer) {
          printer.info.network = printer.customProperties.network.name;
          printer.info.thresholdToSwitchCreatedTimeFormat = $scope.thresholdToSwitchCreatedTimeFormat;
          printer.info.currentDate = $scope.currentDate;

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: 'Printer',
            type: 'printerDetails',
            printer: printer.info,
          }
          $scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: false
          }
        }

        $scope.clearTooltip = function () {
          $scope.tooltipContent = null;
          $scope.tooltipObject = null;
        }

        function setListeners () {
          // $rootScope.$on('REFRESH_MULTI_EDIT_PRINTERS', () => {
          //   initView();
          // });
        }

        var REFRESH_MULTI_EDIT_PRINTERS_listener = $rootScope.$on('REFRESH_MULTI_EDIT_PRINTERS', () => {
          initView();
        });

        $scope.$on('$destroy', function () {
          REFRESH_MULTI_EDIT_PRINTERS_listener();
        })
      }
    ]);
})();
